"use strict";
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * eloomi-platforms-persona (1.0)
 * - This service is using new eloomi project structure. You should be able to make HTTP calls from this UI.
 *
 * The version of the OpenAPI document: 1.0

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationMergeApiFactory = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * IntegrationMergeApi - axios parameter creator
 * @export
 */
const IntegrationMergeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Completes an integration by persisting an account token and starting a recurring background job.
         * @param {MergePublicTokenRequest} [mergePublicTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeIntegration: async (mergePublicTokenRequest, options = {}) => {
            const localVarPath = `/platforms/persona/integrations/merge/complete-integration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "1.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mergePublicTokenRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Deletes integration from Eloomi and from Merge.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteIntegration: async (options = {}) => {
            const localVarPath = `/platforms/persona/integrations/merge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "1.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Deletes integration from Eloomi and from Merge.
         * @param {DeleteMergeIntegrationRequest} [deleteMergeIntegrationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntegrationParameterized: async (deleteMergeIntegrationRequest, options = {}) => {
            const localVarPath = `/platforms/persona/integrations/merge/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "1.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteMergeIntegrationRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets current integration details including whether it\'s enabled or disabled,   scheduled time of the next run, HRIS system details and so on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationDetails: async (options = {}) => {
            const localVarPath = `/platforms/persona/integrations/merge/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "1.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieves a Link Token to initiate Merge Integration setup.
         * @param {GetMergeLinkTokenRequest} [getMergeLinkTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkToken: async (getMergeLinkTokenRequest, options = {}) => {
            const localVarPath = `/platforms/persona/integrations/merge/link-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "1.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(getMergeLinkTokenRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets all Enabled HRIS integrations from Merge for current platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedHrisIntegrations: async (options = {}) => {
            const localVarPath = `/platforms/persona/integrations/merge/supported-hris-integrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "1.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Creates or updates Merge Integration settings for a given platform Merge integration.
         * @param {MergeIntegrationSettings} [mergeIntegrationSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMergeIntegrationSettings: async (mergeIntegrationSettings, options = {}) => {
            const localVarPath = `/platforms/persona/integrations/merge/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "1.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mergeIntegrationSettings, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary The endpoint disables or enables current platform\'s Merge integration.   Boolean value is passed as a request body property.
         * @param {IntegrationEnabledToggleRequest} [integrationEnabledToggleRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleIntegrationEnabled: async (integrationEnabledToggleRequest, options = {}) => {
            const localVarPath = `/platforms/persona/integrations/merge/enabled-toggle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "1.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(integrationEnabledToggleRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * IntegrationMergeApi - functional programming interface
 * @export
 */
const IntegrationMergeApiFp = function (configuration) {
    const localVarAxiosParamCreator = IntegrationMergeApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Completes an integration by persisting an account token and starting a recurring background job.
         * @param {MergePublicTokenRequest} [mergePublicTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeIntegration(mergePublicTokenRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeIntegration(mergePublicTokenRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @summary Deletes integration from Eloomi and from Merge.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async deleteIntegration(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIntegration(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @summary Deletes integration from Eloomi and from Merge.
         * @param {DeleteMergeIntegrationRequest} [deleteMergeIntegrationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIntegrationParameterized(deleteMergeIntegrationRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIntegrationParameterized(deleteMergeIntegrationRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @summary Gets current integration details including whether it\'s enabled or disabled,   scheduled time of the next run, HRIS system details and so on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIntegrationDetails(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIntegrationDetails(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @summary Retrieves a Link Token to initiate Merge Integration setup.
         * @param {GetMergeLinkTokenRequest} [getMergeLinkTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLinkToken(getMergeLinkTokenRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLinkToken(getMergeLinkTokenRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @summary Gets all Enabled HRIS integrations from Merge for current platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportedHrisIntegrations(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportedHrisIntegrations(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @summary Creates or updates Merge Integration settings for a given platform Merge integration.
         * @param {MergeIntegrationSettings} [mergeIntegrationSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putMergeIntegrationSettings(mergeIntegrationSettings, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putMergeIntegrationSettings(mergeIntegrationSettings, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @summary The endpoint disables or enables current platform\'s Merge integration.   Boolean value is passed as a request body property.
         * @param {IntegrationEnabledToggleRequest} [integrationEnabledToggleRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleIntegrationEnabled(integrationEnabledToggleRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleIntegrationEnabled(integrationEnabledToggleRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * IntegrationMergeApi - factory interface
 * @export
 */
const IntegrationMergeApiFactory = function (configuration, basePath, axios) {
    const localVarFp = IntegrationMergeApiFp(configuration);
    return {
        /**
         *
         * @summary Completes an integration by persisting an account token and starting a recurring background job.
         * @param {MergePublicTokenRequest} [mergePublicTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeIntegration(mergePublicTokenRequest, options) {
            return localVarFp.completeIntegration(mergePublicTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Deletes integration from Eloomi and from Merge.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteIntegration(options) {
            return localVarFp.deleteIntegration(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Deletes integration from Eloomi and from Merge.
         * @param {DeleteMergeIntegrationRequest} [deleteMergeIntegrationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntegrationParameterized(deleteMergeIntegrationRequest, options) {
            return localVarFp.deleteIntegrationParameterized(deleteMergeIntegrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets current integration details including whether it\'s enabled or disabled,   scheduled time of the next run, HRIS system details and so on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationDetails(options) {
            return localVarFp.getIntegrationDetails(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves a Link Token to initiate Merge Integration setup.
         * @param {GetMergeLinkTokenRequest} [getMergeLinkTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkToken(getMergeLinkTokenRequest, options) {
            return localVarFp.getLinkToken(getMergeLinkTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets all Enabled HRIS integrations from Merge for current platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedHrisIntegrations(options) {
            return localVarFp.getSupportedHrisIntegrations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates or updates Merge Integration settings for a given platform Merge integration.
         * @param {MergeIntegrationSettings} [mergeIntegrationSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMergeIntegrationSettings(mergeIntegrationSettings, options) {
            return localVarFp.putMergeIntegrationSettings(mergeIntegrationSettings, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary The endpoint disables or enables current platform\'s Merge integration.   Boolean value is passed as a request body property.
         * @param {IntegrationEnabledToggleRequest} [integrationEnabledToggleRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleIntegrationEnabled(integrationEnabledToggleRequest, options) {
            return localVarFp.toggleIntegrationEnabled(integrationEnabledToggleRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.IntegrationMergeApiFactory = IntegrationMergeApiFactory;
//# sourceMappingURL=integration-merge-api.js.map